var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"box distance"},[_c('span',{staticClass:"title"},[_vm._v(_vm._s(_vm.title))]),_c('div',{staticClass:"items"},_vm._l((_vm.data),function(item,index){return _c('span',{key:index,class:{current: index === _vm.n},on:{"click":function($event){return _vm.change(index)}}},[_vm._v(" "+_vm._s(item.label)+" ")])}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }